import * as THREE from 'three'
import React, { useMemo } from 'react'
import { extrudeSettings } from '../../../../../../utils/Functions';

const LatticeModel = ({ width, height }) => {
    const unitSize = 0.012;
    
    const railThicknessHr = unitSize;
    const railThicknessVrLarge = unitSize * 3;
    const railThicknessVrSmall = unitSize * 1.2;

    const distanceRailHr = unitSize / 2;
    const heightPatternHr = railThicknessHr * 3 + distanceRailHr * 2;
    const countPatternHr = Math.floor(height / (heightPatternHr * 2));
    const distancePatternHr = (height - heightPatternHr * countPatternHr) / (countPatternHr + 1)

    const distanceRailVr = distancePatternHr;
    const widthPatternVr = railThicknessVrLarge * 2 + distanceRailVr * 2 + railThicknessVrSmall;
    const countPatternVr = Math.floor(width / (widthPatternVr * 1.5));
    const distancePatternVr = (width - widthPatternVr * countPatternVr) / (countPatternVr + 1)

    const patternHrModel = useMemo(() => {
        let model = []
        
        const rail_upper = new THREE.Shape();
        rail_upper.moveTo(-width / 2, -(railThicknessHr * 0 + distanceRailHr * 0));
        rail_upper.lineTo(width / 2, -(railThicknessHr * 0 + distanceRailHr * 0));
        rail_upper.lineTo(width / 2, -(railThicknessHr * 1 + distanceRailHr * 0));
        rail_upper.lineTo(-width / 2, -(railThicknessHr * 1 + distanceRailHr * 0));
        rail_upper.closePath();

        const rail_mid = new THREE.Shape();
        rail_mid.moveTo(-width / 2, -(railThicknessHr * 1 + distanceRailHr * 1));
        rail_mid.lineTo(width / 2, -(railThicknessHr * 1 + distanceRailHr * 1));
        rail_mid.lineTo(width / 2, -(railThicknessHr * 2 + distanceRailHr * 1));
        rail_mid.lineTo(-width / 2, -(railThicknessHr * 2 + distanceRailHr * 1));
        rail_mid.closePath();

        const rail_under = new THREE.Shape();
        rail_under.moveTo(-width / 2, -(railThicknessHr * 2 + distanceRailHr * 2));
        rail_under.lineTo(width / 2, -(railThicknessHr * 2 + distanceRailHr * 2));
        rail_under.lineTo(width / 2, -(railThicknessHr * 3 + distanceRailHr * 2));
        rail_under.lineTo(-width / 2, -(railThicknessHr * 3 + distanceRailHr * 2));
        rail_under.closePath();

        model.push(rail_upper);
        model.push(rail_mid);
        model.push(rail_under);

        return model;
    
    }, [width, height])

    
    const patternVrModel = useMemo(() => {
        let model = [];

        const rail_left = new THREE.Shape();
        rail_left.moveTo(0, -height / 2);
        rail_left.lineTo(0, height / 2);
        rail_left.lineTo(railThicknessVrLarge, height / 2);
        rail_left.lineTo(railThicknessVrLarge, -height / 2);
        rail_left.closePath();

        const rail_mid = new THREE.Shape();
        rail_mid.moveTo(railThicknessVrLarge * 1 + distanceRailVr * 1 + railThicknessVrSmall * 0, -height / 2);
        rail_mid.lineTo(railThicknessVrLarge * 1 + distanceRailVr * 1 + railThicknessVrSmall * 0, height / 2);
        rail_mid.lineTo(railThicknessVrLarge * 1 + distanceRailVr * 1 + railThicknessVrSmall * 1, height / 2);
        rail_mid.lineTo(railThicknessVrLarge * 1 + distanceRailVr * 1 + railThicknessVrSmall * 1, -height / 2);
        rail_mid.closePath();

        const rail_right = new THREE.Shape();
        rail_right.moveTo(railThicknessVrLarge * 1 + distanceRailVr * 2 + railThicknessVrSmall * 1, -height / 2);
        rail_right.lineTo(railThicknessVrLarge * 1 + distanceRailVr * 2 + railThicknessVrSmall * 1, height / 2);
        rail_right.lineTo(railThicknessVrLarge * 2 + distanceRailVr * 2 + railThicknessVrSmall * 1, height / 2);
        rail_right.lineTo(railThicknessVrLarge * 2 + distanceRailVr * 2 + railThicknessVrSmall * 1, -height / 2);
        rail_right.closePath();

        model.push(rail_left);
        model.push(rail_mid);
        model.push(rail_right);
        
        return model;
    }, [width, height])
    
    return (
        <group>
            {new Array(countPatternHr).fill("").map((_, index) =>
                <mesh key={`hr-pattern-${index}`} name='pattern-hr' position={[0, -(distancePatternHr * (index + 1) + heightPatternHr * index) , 0.05]}>
                    <extrudeGeometry args={[patternHrModel, extrudeSettings(0.1)]} />
                    <meshStandardMaterial color={'#FFFFFF'} side={THREE.DoubleSide} metalness={0.5} />
                </mesh>
            )}
            {new Array(countPatternVr).fill("").map((_, index) =>
                <mesh key={`vr-pattern-${index}`} name='pattern-vr' position={[(-width / 2 + distancePatternVr * (index + 1) + widthPatternVr * index), -height / 2 , 0.05]}>
                    <extrudeGeometry args={[patternVrModel, extrudeSettings(0.1)]} />
                    <meshStandardMaterial color={'#FFFFFF'} side={THREE.DoubleSide} metalness={0.5} />
                </mesh>
            )}
        </group>
    )
}

export default LatticeModel